const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
];

const arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
];

const fixNumbers = (str) => {
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
};

const CleanArabicString=(arabicString)=>{
  let ss = '';
    if(arabicString && arabicString.length > 0){
    ss = arabicString.toLowerCase();
    ss = ss.replace(/إ/g, "ا");
    ss = ss.replace(/آ/g, "ا");
    ss = ss.replace(/أ/g, "ا");
    ss = ss.replace(/ة/g, "ه");
    ss = fixNumbers(ss);
    ss = ss.replace(/\s\s+/g, " ").trim();}
    else{ ss = ''}
    return ss
  }

export default CleanArabicString